/// frontend/src/services/api.js
import axios from 'axios';

// const getAPIBaseURL = () => {
//   if (typeof window !== 'undefined') {
//     const hostname = window.location.hostname;
    
//     if (hostname === 'techpolymer.ir' || hostname === 'www.techpolymer.ir') {
//       return 'https://techpolymer.ir/api';
//     }
    
//     if (hostname === 'localhost' || hostname === '127.0.0.1') {
//       return 'http://127.0.0.1:8000';
//     }
//   }
  
//   return '/api';
// };

// const API_BASE_URL = getAPIBaseURL();

// console.log('🚀 API Base URL:', API_BASE_URL);

const API_BASE_URL = 'https://techpolymer.ir';
// const API_BASE_URL = 'http://127.0.0.1:8000';

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// تابع کمکی برای ساخت URL کامل تصاویر
export const getFullImageUrl = (imagePath) => {
  if (!imagePath) return '/api/placeholder/400/300';
  if (imagePath.startsWith('http')) return imagePath;
  return `${API_BASE_URL}${imagePath}`;
};

export const apiService = {
  // دریافت داده‌های صفحه اصلی
  getHomeData: () => api.get('/home/'),
  
  // محصولات
  getProducts: (params = {}) => {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        queryParams.append(key, params[key]);
      }
    });
    return api.get(`/products/?${queryParams.toString()}`);
  },
  
  getProduct: (slug) => api.get(`/products/?slug=${slug}`),
  
  // دسته‌بندی‌ها
  getCategories: () => api.get('/categories/'),
  
  // بلاگ
  getPosts: (params = {}) => {
    const queryParams = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });
    
    const url = `/posts/${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    console.log('API Call:', url);
    
    return api.get(url);
  },
  getPost: (slug) => api.get(`/posts/?slug=${slug}`),
  getBlogCategories: () => api.get('/blog-categories/'),
  
  // نظرات
  getPostComments: (postId) => api.get(`/posts/${postId}/comments/`),
  submitComment: (postId, data) => api.post(`/posts/${postId}/submit_comment/`, data),
  
  // مقالات مرتبط
  getRelatedPosts: (postId) => api.get(`/posts/${postId}/related/`),
  
  // تعامل با پست
  likePost: (postId) => api.post(`/posts/${postId}/like/`),
  
  // پورتفولیو
  getTeamMembers: (params = {}) => api.get('/portfolio/members/', { params }),
  getTeamMember: (id) => api.get(`/portfolio/members/${id}/`),
  getMemberProjects: (memberId) => api.get(`/portfolio/members/${memberId}/projects/`),
  
  // پروژه‌ها
  getProjects: (params = {}) => api.get('/portfolio/projects/', { params }),
  
   // گالری
  getGalleryImages: (params = {}) => {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        queryParams.append(key, params[key]);
      }
    });
    return api.get(`/gallery-images/?${queryParams.toString()}`);
  },
  
  getGalleryVideos: (params = {}) => {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        queryParams.append(key, params[key]);
      }
    });
    return api.get(`/gallery-videos/?${queryParams.toString()}`);
  },
  
  getGalleryCategories: () => api.get('/gallery-categories/'),
  
  downloadImage: (imageId) => api.post(`/gallery-images/${imageId}/download/`),
  
  // تماس
  submitContact: (data) => api.post('/contact/', data),

  // افزایش تعداد بازدید پست
  incrementPostView: (postId) => api.post(`/posts/${postId}/increment-view/`),

  // درباره ما
  getAboutData: () => api.get('/about/'),

    // دسته‌بندی‌های گالری
  getGalleryCategories: () => api.get('/gallery-categories/'),
  
  // دسته‌بندی‌های بلاگ
  getBlogCategories: () => api.get('/blog-categories/'),

  // خدمات
  getServices: (params = {}) => {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });
    return api.get(`/services/services/?${queryParams.toString()}`);
  },
  getService: (slug) => {
    return api.get(`/services/services/?slug=${slug}`);
  },
  getServiceBySlug: (slug) => api.get(`/services/services/?slug=${slug}`),
  getServiceCategories: (params = {}) => api.get('/services/categories/', { params }),
  submitServiceRequest: (data) => api.post('/services/requests/', data),
  //incrementServiceView: (serviceId) => api.post(`/services/services/${serviceId}/increment_view/`),
  
  // داده‌های خدمات برای صفحه اصلی
  getServicesHomeData: () => api.get('/services/home-data/'),
  
  getSiteSettings: () => api.get('/site-settings/'),
  
};

export default api;